import { useContext, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useParams } from "react-router";

import Spinner from "../../../shared/components/spinner/spinner";
import { IBlock } from "../../../shared/components/widgets-layout/widgets-layout";
import AuthContext from "../../../shared/context/auth-context";
import {useHttpNonTable} from "../../../shared/hooks/use-httpNonTable";
import { postSingleNonTable } from "../../../shared/utils/api";
import { validateLoadingStatusNew, IMultyChart } from "../../../shared/utils/utils";
import { populateHistoryObj, IChartResultsCols } from "./report-details-columns";

export interface IRowStatus {
  opt_thresh_id?: string;
  approved_id?: string;
}

export interface ICol {
  [index: string]: any; // eslint-disable-line
}

export interface IAllColsResponse {
  columns: ICol[];
  thresholds?: number;
  time_unit?: string;
}

export interface ITableConfig {
  allHistoryCols?: IAllColsResponse;
  options: any; // eslint-disable-line
  applySelectedColor: any; // eslint-disable-line
  widgetData?: IBlock;
}

const ChartHoc = ({ allHistoryCols, widgetData, options, applySelectedColor }: ITableConfig) => {
  const [historyChartData, setHistoryChartData] = useState<IMultyChart>({labels: [], datasets: []});

  const authCtx = useContext(AuthContext);
  const params = useParams();

  const { sendRequest: getHistoryDataSortBy, status: getHistoryDataStatus, data: getHistoryDataData, error: getHistoryDataSortByError } = useHttpNonTable(postSingleNonTable, false, authCtx.token, "report", "analytics");

  useEffect(() => {
    if (getHistoryDataStatus === "completed" && !getHistoryDataSortByError && allHistoryCols) {
      const getHistory:IChartResultsCols = populateHistoryObj(getHistoryDataData.data, allHistoryCols);
      const historyDataPrep = {...getHistory, datasets: getHistory.datasets.filter((dataset:any) => widgetData?.settings?.selectedColumns.indexOf(dataset.key) !== -1)}; // eslint-disable-line
      setHistoryChartData(historyDataPrep);
    }
  }, [getHistoryDataStatus]);

  useEffect(() => {
    getHistoryDataSortBy(`history_trend/${params.id}${"?order_by=start_date asc"}`, {
      columns: widgetData?.settings?.selectedColumns,
      threshold: widgetData?.settings?.selectedThreshold,
    }, undefined, "none");
  }, [widgetData]);

  return (
    <div className="reportDetailsClassic-chart show">
      {validateLoadingStatusNew([getHistoryDataStatus]) && <Spinner />}
      <Line options={options} data={applySelectedColor(historyChartData)} />
    </div>
  );
};

export default ChartHoc;
